'use strict';
import _ from 'lodash';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import RouteConstants from '../constants/RouteConstants';
import ErrorHandlerConstants from '../constants/ErrorHandlerConstants';
import CommonAPI from '../apis/CommonAPI.js';
import {errorHandled} from '../actions/ErrorHandlerActions';
import {handleApplicationSubmitErrorNotification} from '../actions/ApplicationActions';
import {getApiErrorInfo} from '../apis/ApiHelper';
import {v4 as uuidV4} from 'uuid';

class ErrorHandlerClass {
    constructor() {
        autoBind(this);
        window.addEventListener('error', this.handleError);
    }

    createErrorMessage (error) {
        // build up the error object to be logged
        const apiErrorInfo = getApiErrorInfo(error);
        const message = {
            message: error.toString(),
            stack: _.get(error, 'stack')
        };

        const errorMessage = _.merge({}, message, apiErrorInfo);

        // if there is no correlation Id in the error (front-end-only exceptions), then we generate a new one for logging purpose 
        if (!errorMessage.correlationId) {
            errorMessage.correlationId = uuidV4();
            errorMessage.isErrorLogged= false;
        } else {
            errorMessage.isErrorLogged = true;
        }

        return errorMessage;
    }

    handleError(event) {
        const errorMessage = this.createErrorMessage(event.error);
        if (!errorMessage.isErrorLogged) {
            // log the error
            CommonAPI.logError(errorMessage);
        }
        
        // update error handler store
        errorHandled(errorMessage.correlationId);

        //if the error code is a fms submit error we handle them in a different way
        if (errorMessage.errorCode && errorMessage.errorCode.indexOf(ErrorHandlerConstants.ErrorCodes.FMS_SUBMIT) > -1) {
            handleApplicationSubmitErrorNotification(errorMessage.errorCode);
        } else {
            // redirect to the error page
            browserHistory.push(RouteConstants.Error);
        }
    }

    logError(error) {
        // build up error message
        const errorMessage = this.createErrorMessage(error);

        // log the error
        CommonAPI.logError(errorMessage);

        return errorMessage;
    }
}

// singleton
const ErrorHandler = new ErrorHandlerClass();

export default ErrorHandler;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./core/ErrorHandler.js